export default "__VITE_ASSET__D70$G6ht__"